/* BeeDTF · Tote bags: buy blank, or add a custom DTF print and preview it on the real bag photo at true size.
   Product data: variants with options (Color?) + Print (Blank / Custom print) and metafield beedtf.mockup
   { img, ppi (px per inch on a 1000px-wide photo), cx, cy (print area centre, px), aw, ah (print area, inches) }. */
(() => {
  const IN = '″';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const r1 = (n) => Math.round(n * 10) / 10;
  const f1 = (n) => Math.floor(n * 10 + 1e-6) / 10;

  /* ---------- print files go to Google Drive (BeeDTF uploads Apps Script); the order gets the Drive link ---------- */
  const DRIVE = { url: 'https://script.google.com/macros/s/AKfycbwOV5-mEootbo8WzncOWn_1EaEnh751Qp2sMyvIp1jFwB3YH1TxVVSMnjMUrB-Txmo/exec', key: 'bee_8rNHHAr2Vmzxt2jo4zOPZwXS' };
  const SHOPIFY_MAX = 20 * 1024 * 1024, SMALL_MAX = 35 * 1024 * 1024, DRIVE_MAX = 500 * 1024 * 1024;
  const mb = (b) => `${(b / 1048576).toFixed(b < 10485760 ? 1 : 0)} MB`;
  const drivePost = (body) => fetch(DRIVE.url, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify({ key: DRIVE.key, ...body }) }).then((r) => r.json());
  const putFile = (url, file, onp) => new Promise((resolve, reject) => {
    const x = new XMLHttpRequest();
    x.open('PUT', url);
    x.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
    x.upload.onprogress = (e) => { if (e.lengthComputable) onp(e.loaded / e.total); };
    x.onload = () => {
      if (x.status === 200 || x.status === 201) { try { resolve(JSON.parse(x.responseText)); } catch (e) { reject(e); } }
      else reject(new Error(`Upload failed (${x.status})`));
    };
    x.onerror = () => reject(new Error('Upload blocked'));
    x.send(file);
  });
  const toB64 = (file) => new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(',')[1] || '');
    r.onerror = reject;
    r.readAsDataURL(file);
  });
  /* one code per visitor (kept 7 days) so all of their uploads land in the same Drive folder */
  const SESSION = (() => {
    try { const s = JSON.parse(localStorage.getItem('bee_session') || 'null'); if (s && s.id && Date.now() - s.t < 7 * 864e5) return s.id; } catch (e) { /* ignore */ }
    const id = 'S' + Math.random().toString(36).slice(2, 8).toUpperCase();
    try { localStorage.setItem('bee_session', JSON.stringify({ id, t: Date.now() })); } catch (e) { /* ignore */ }
    return id;
  })();
  const thumbFile = (file, name) => new Promise((resolve) => {
    if (!/^image\/(png|jpe?g|webp|gif|svg\+xml)$/.test(file.type || '')) { resolve(null); return; }
    const u = URL.createObjectURL(file);
    const im = new Image();
    im.onload = () => {
      try {
        const k = Math.min(1, 800 / Math.max(im.naturalWidth || 800, im.naturalHeight || 800));
        const c = document.createElement('canvas'); c.width = Math.max(1, Math.round((im.naturalWidth || 800) * k)); c.height = Math.max(1, Math.round((im.naturalHeight || 800) * k));
        c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
        c.toBlob((b) => { URL.revokeObjectURL(u); resolve(b ? new File([b], `preview-${(name || file.name).replace(/\.[^.]+$/, '')}.png`, { type: 'image/png' }) : null); }, 'image/png');
      } catch (e) { URL.revokeObjectURL(u); resolve(null); }
    };
    im.onerror = () => { URL.revokeObjectURL(u); resolve(null); };
    im.src = u;
  });
  const driveUpload = (file, meta, onChange) => {
    const job = { file, state: 'busy', pct: 0 };
    const set = (s, p) => { job.state = s; job.pct = p || 0; if (onChange) onChange(job); };
    job.promise = (async () => {
      const base = { ref: meta.ref, session: SESSION, name: file.name, type: file.type || 'application/octet-stream', size: file.size, origin: location.origin, product: meta.product || '', label: meta.label || '' };
      set('busy', 0);
      try {
        const init = await drivePost({ action: 'init', ...base });
        if (!init.ok) throw new Error(init.error || 'init');
        const res = await putFile(init.uploadUrl, file, (p) => set('busy', p * 0.99));
        if (!res.id) throw new Error('No file id');
        set('done', 1);
        return `https://drive.google.com/file/d/${res.id}/view`;
      } catch (e1) {
        if (file.size > SMALL_MAX) { set('error'); throw e1; }
        try {
          set('busy', 0.3);
          const r = await drivePost({ action: 'small', ...base, data: await toB64(file) });
          if (!r.ok) throw new Error(r.error || 'small');
          set('done', 1);
          return r.url;
        } catch (e2) { set('error'); throw e2; }
      }
    })();
    job.promise.catch(() => {});
    return job;
  };
  const buzz = (el, text) => { el.innerHTML = `<span class="bee-buzz">Bzzz…</span> ${text}`; };

  /* ---------- design clean-up: remove a solid background, trim empty space ---------- */
  const frame = () => new Promise((r) => { let done = false; const go = () => { if (!done) { done = true; setTimeout(r, 30); } }; requestAnimationFrame(go); setTimeout(go, 120); });
  const loadImg = (url) => new Promise((resolve, reject) => { const i = new Image(); i.onload = () => resolve(i); i.onerror = reject; i.src = url; });
  const analyze = (img) => {
    const W = img.naturalWidth, H = img.naturalHeight;
    const k = Math.min(1, 900 / Math.max(W, H));
    const w = Math.max(1, Math.round(W * k)), h = Math.max(1, Math.round(H * k));
    const c = document.createElement('canvas'); c.width = w; c.height = h;
    const g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(img, 0, 0, w, h);
    const a = g.getImageData(0, 0, w, h).data;
    let border = 0, clear = 0;
    const bins = new Map();
    const visit = (x, y) => {
      const i = (y * w + x) * 4;
      border++;
      if (a[i + 3] < 24) { clear++; return; }
      const key = ((a[i] >> 4) << 8) | ((a[i + 1] >> 4) << 4) | (a[i + 2] >> 4);
      bins.set(key, (bins.get(key) || 0) + 1);
    };
    for (let x = 0; x < w; x++) { visit(x, 0); visit(x, h - 1); }
    for (let y = 1; y < h - 1; y++) { visit(0, y); visit(w - 1, y); }
    const opaque = border - clear;
    let top = 0;
    bins.forEach((n) => { if (n > top) top = n; });
    const hasBg = opaque / border > 0.6;
    const solidBg = hasBg && top / Math.max(1, opaque) > 0.55;
    let x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
      if (a[(y * w + x) * 4 + 3] > 16) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    const area = x1 < 0 ? 1 : ((x1 - x0 + 1) * (y1 - y0 + 1)) / (w * h);
    return { hasBg, solidBg, trimmable: !hasBg && x1 >= 0 && area < 0.9 };
  };
  const processImage = async (img, removeBg) => {
    const W = img.naturalWidth, H = img.naturalHeight;
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const g = c.getContext('2d', { willReadFrequently: true });
    g.drawImage(img, 0, 0);
    const id = g.getImageData(0, 0, W, H);
    const a = id.data;
    if (removeBg) {
      let r = 0, gg = 0, b = 0, n = 0;
      const sample = (x, y) => { const i = (y * W + x) * 4; r += a[i]; gg += a[i + 1]; b += a[i + 2]; n++; };
      for (let t = 0; t < 8; t++) { sample(t, t); sample(W - 1 - t, t); sample(t, H - 1 - t); sample(W - 1 - t, H - 1 - t); }
      r /= n; gg /= n; b /= n;
      const tol = 42, tol2 = tol * tol, soft2 = (tol * 2) * (tol * 2);
      const d2 = (i) => { const dr = a[i] - r, dg = a[i + 1] - gg, db = a[i + 2] - b; return dr * dr + dg * dg + db * db; };
      const N = W * H;
      const mask = new Uint8Array(N);
      const q = new Uint32Array(N);
      let qh = 0, qt = 0;
      const push = (p) => { if (!mask[p] && d2(p * 4) <= tol2) { mask[p] = 1; q[qt++] = p; } };
      for (let x = 0; x < W; x++) { push(x); push((H - 1) * W + x); }
      for (let y = 0; y < H; y++) { push(y * W); push(y * W + W - 1); }
      while (qh < qt) {
        const p = q[qh++], x = p % W;
        if (x > 0) push(p - 1);
        if (x < W - 1) push(p + 1);
        if (p >= W) push(p - W);
        if (p < N - W) push(p + W);
      }
      for (let p = 0; p < N; p++) {
        if (mask[p]) { a[p * 4 + 3] = 0; continue; }
        const x = p % W;
        const edge = (x > 0 && mask[p - 1]) || (x < W - 1 && mask[p + 1]) || (p >= W && mask[p - W]) || (p < N - W && mask[p + W]);
        if (edge) {
          const dd = d2(p * 4);
          if (dd < soft2) a[p * 4 + 3] = Math.round(a[p * 4 + 3] * Math.min(1, (Math.sqrt(dd) - tol) / tol));
        }
      }
    }
    let x0 = W, y0 = H, x1 = -1, y1 = -1;
    for (let y = 0; y < H; y++) {
      const row = y * W * 4;
      for (let x = 0; x < W; x++) {
        if (a[row + x * 4 + 3] > 8) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; y1 = y; }
      }
    }
    if (x1 < 0) throw new Error('empty');
    g.putImageData(id, 0, 0);
    const cw = x1 - x0 + 1, ch = y1 - y0 + 1;
    const out = document.createElement('canvas'); out.width = cw; out.height = ch;
    out.getContext('2d').drawImage(c, x0, y0, cw, ch, 0, 0, cw, ch);
    const blob = await new Promise((res) => out.toBlob(res, 'image/png'));
    if (!blob) throw new Error('export');
    return blob;
  };
  const CSS = `.bee-bag .bee-bag__tools{display:flex;flex-direction:column;gap:8px;padding:12px 14px;border-radius:14px;background:#FFFDF6;border:1px solid var(--bee-line)}
.bee-bag .bee-bag__tools[hidden]{display:none}
.bee-bag .bee-bag__tool-msg{margin:0;display:flex;align-items:flex-start;justify-content:space-between;gap:10px;font-size:14px;line-height:1.45}
.bee-bag .bee-bag__tool-msg strong{display:block}
.bee-bag .bee-bag__tool-msg.is-warn{color:#8A4B00}.bee-bag .bee-bag__tool-msg.is-ok{color:#155E5E}.bee-bag .bee-bag__tool-msg.is-err{color:#B42318}.bee-bag .bee-bag__tool-msg.is-busy{color:var(--bee-honey-text);font-weight:700}
.bee-bag .bee-bag__tool{align-self:flex-start;min-height:44px;padding:0 18px;border-radius:12px;border:0;background:var(--bee-ink);color:var(--bee-honey);font:800 15px var(--bee-body);cursor:pointer}
.bee-bag .bee-bag__tool-link{flex-shrink:0;border:1px solid var(--bee-line);background:#fff;border-radius:999px;padding:6px 14px;font:700 13px var(--bee-body);color:var(--bee-ink);cursor:pointer}
.bee-bag .bee-bag__team{display:flex;align-items:flex-start;gap:10px;padding-top:8px;border-top:1px dashed var(--bee-line);font-size:14px;line-height:1.4;cursor:pointer}
.bee-bag .bee-bag__team input{width:20px;height:20px;margin:1px 0 0;flex-shrink:0;accent-color:var(--bee-ink)}
.bee-bag .bee-bag__tag{display:inline-block;margin-left:4px;padding:1px 8px;border-radius:999px;background:var(--bee-teal);color:#fff;font-size:11px;font-weight:800}
.bee-bag .bee-bag__up{margin:0;font-size:14px;font-weight:700;color:var(--bee-honey-text)}.bee-bag .bee-bag__up.is-done{color:#155E5E}.bee-bag .bee-bag__up.is-error{color:#B42318}
.bee-bag .bee-bag__upbar{display:block;height:4px;margin-top:6px;border-radius:4px;background:#F3E6C4;overflow:hidden}.bee-bag .bee-bag__upbar i{display:block;height:100%;width:calc(var(--p,0)*100%);background:var(--bee-honey);transition:width .2s}
.bee-buzz{display:inline-block;animation:bee-buzz .18s linear infinite}@keyframes bee-buzz{0%,100%{transform:translate(0,0) rotate(0)}25%{transform:translate(.7px,-.6px) rotate(-2deg)}50%{transform:translate(-.6px,.5px) rotate(1.5deg)}75%{transform:translate(.5px,.7px) rotate(-1deg)}}@media (prefers-reduced-motion:reduce){.bee-buzz{animation:none}}
.bee-bag .bee-bag__handle{touch-action:none}.bee-bag .bee-bag__handle.is-nw,.bee-bag .bee-bag__handle.is-se{cursor:nwse-resize}.bee-bag .bee-bag__handle.is-ne,.bee-bag .bee-bag__handle.is-sw{cursor:nesw-resize}`;

  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const data = JSON.parse(root.querySelector('[data-json]').textContent);
    const mk = data.mockup;
    const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency || 'USD' });
    const fmt = (c) => money.format(c / 100);
    const $ = (s) => root.querySelector(s);
    const printIdx = data.options.findIndex((o) => o.toLowerCase() === 'print');
    const colorIdx = data.options.findIndex((o) => o.toLowerCase() === 'color');

    const state = {
      color: colorIdx >= 0 ? (data.variants.find((v) => v.available) || data.variants[0]).options[colorIdx] : null,
      custom: false,
      qty: 1,
      file: null, url: null, px: null, ratio: null, vector: false,
      w: null, h: null, pos: null, ackFor: null, notes: '',
      orig: null, info: null, edit: null, busy: null, toolErr: '', team: false, job: 0,
      ref: '', img: null, up: null, origUp: null
    };
    const productName = (root.querySelector('h1') || {}).textContent || document.title;
    if (!document.getElementById('bee-bag-css')) { const st = document.createElement('style'); st.id = 'bee-bag-css'; st.textContent = CSS; document.head.appendChild(st); }
    const toolsEl = document.createElement('div');
    toolsEl.className = 'bee-bag__tools';
    toolsEl.hidden = true;

    const els = {
      gallery: $('[data-gallery]'), main: $('[data-main]'), thumbs: $('[data-thumbs]'),
      mock: $('[data-mock]'), mockCap: $('[data-mock-cap]'),
      colors: $('[data-colors]'), price: $('[data-price]'), priceNote: $('[data-price-note]'),
      print: $('[data-print]'), custom: $('[data-custom]'),
      file: $('[data-file]'), drop: $('[data-drop]'), dropTitle: $('[data-drop-title]'), dropSub: $('[data-drop-sub]'),
      sizeBox: $('[data-size]'), w: $('[data-w]'), h: $('[data-h]'), fill: $('[data-fill]'), measure: $('[data-measure]'),
      qa: $('[data-qa]'), qty: $('[data-qty]'), total: $('[data-total]'), add: $('[data-add]'), addLabel: $('[data-add-label]'),
      err: $('[data-err]'), notes: $('[data-notes]')
    };
    const addText = els.addLabel.textContent;
    const upEl = document.createElement('p');
    upEl.className = 'bee-bag__up';
    upEl.hidden = true;
    els.drop.after(upEl);
    upEl.after(toolsEl);
    if (DRIVE.url) els.dropSub.textContent = 'PNG with a transparent background works best · up to 500 MB';
    const paintUp = () => {
      const j = state.up;
      upEl.hidden = !j;
      if (!j) return;
      upEl.className = `bee-bag__up is-${j.state}`;
      upEl.innerHTML = j.state === 'busy' ? `<span class="bee-buzz">Bzzz…</span> uploading your file ${Math.round(j.pct * 100)}%<span class="bee-bag__upbar" style="--p:${j.pct}"><i></i></span>`
        : j.state === 'done' ? `✓ File uploaded (${mb(j.file.size)})`
        : j.file.size > SHOPIFY_MAX ? 'Upload failed. Please check your connection and choose the file again.' : '';
      if (!upEl.textContent) upEl.hidden = true;
    };
    const startUp = (file) => driveUpload(file, { ref: state.ref, product: productName.trim().replace(/\s+/g, ' ').slice(0, 60), label: state.edit ? (state.edit === 'bg' ? 'background removed' : 'trimmed') : '' }, (job) => { if (job === state.up) paintUp(); });
    const thumbOf = () => new Promise((resolve) => {
      const im = state.img;
      if (!im || !im.naturalWidth) { resolve(null); return; }
      const k = Math.min(1, 1200 / Math.max(im.naturalWidth, im.naturalHeight));
      const c = document.createElement('canvas'); c.width = Math.round(im.naturalWidth * k); c.height = Math.round(im.naturalHeight * k);
      try { c.getContext('2d').drawImage(im, 0, 0, c.width, c.height); c.toBlob((b) => resolve(b), 'image/png'); } catch (e) { resolve(null); }
    });

    const variant = () => data.variants.find((v) => (colorIdx < 0 || v.options[colorIdx] === state.color)
      && (printIdx < 0 || v.options[printIdx] === (state.custom ? data.printValue : data.blankValue)));
    const priceOf = (custom) => {
      const v = data.variants.find((x) => (colorIdx < 0 || x.options[colorIdx] === state.color) && x.options[printIdx] === (custom ? data.printValue : data.blankValue));
      return v ? v.price : 0;
    };

    /* ---------- size & quality ---------- */
    const area = () => ({ w: mk.aw, h: mk.ah });
    const fitArea = () => {
      if (!state.ratio) return { w: mk.aw, h: mk.ah };
      const k = Math.min(mk.aw, mk.ah / state.ratio);
      return { w: f1(k), h: f1(k * state.ratio) };
    };
    const quality = () => {
      const out = { level: 'ok', msgs: [] };
      if (!state.w || !state.h) return out;
      if (state.w > mk.aw + 0.05 || state.h > mk.ah + 0.05) {
        out.level = 'bad';
        out.msgs.push(`<strong>Bigger than the print area.</strong> This bag prints up to ${mk.aw}${IN} × ${mk.ah}${IN}.`);
      }
      if (state.px && !state.vector) {
        const dpi = Math.round(Math.min(state.px.w / state.w, state.px.h / state.h));
        if (dpi < 150) { out.level = 'bad'; out.msgs.push(`<strong>This will likely print blurry</strong> (${dpi} DPI at this size). Upload a larger file or make the design smaller.`); }
        else if (dpi < 240) { if (out.level === 'ok') out.level = 'soft'; out.msgs.push(`<strong>Slightly soft</strong> (${dpi} DPI). It should look fine, but fine details may blur a little.`); }
      }
      return out;
    };
    const sig = () => `${state.w}x${state.h}`;

    /* ---------- mockup ---------- */
    const imgW = 1000;
    const clampPos = (x, y) => {
      const a = area();
      const hw = (a.w - state.w) / 2, hh = (a.h - state.h) / 2;
      return { x: Math.max(-Math.max(0, hw), Math.min(Math.max(0, hw), x)), y: Math.max(-Math.max(0, hh), Math.min(Math.max(0, hh), y)) };
    };
    const mockSVG = () => {
      const p = mk.ppi;
      const aw = mk.aw * p, ah = mk.ah * p;
      const ax = mk.cx - aw / 2, ay = mk.cy - ah / 2;
      let art = '';
      if (state.url && state.w) {
        const w = state.w * p, h = state.h * p;
        const pos = state.pos || { x: 0, y: 0 };
        const x = mk.cx + pos.x * p - w / 2, y = mk.cy + pos.y * p - h / 2;
        art = `<g data-drag class="bee-bag__drag"><image href="${state.url}" x="${x}" y="${y}" width="${w}" height="${h}" preserveAspectRatio="none"/><rect x="${x}" y="${y}" width="${w}" height="${h}" fill="rgba(0,0,0,0)" stroke="#E09A00" stroke-width="2.5" stroke-dasharray="10 6"/>`
          + [['nw', x, y], ['ne', x + w, y], ['sw', x, y + h], ['se', x + w, y + h]].map(([c, hx, hy]) => `<circle data-resize="${c}" class="bee-bag__handle is-${c}" cx="${hx}" cy="${hy}" r="15" fill="#fff" stroke="#E09A00" stroke-width="4"><title>Drag to resize</title></circle>`).join('')
          + '</g>'
          + `<text x="${x + w / 2}" y="${y - 12}" text-anchor="middle" font-size="24" font-weight="800" fill="#231F20" font-family="Figtree, Arial, sans-serif">${state.w}${IN}</text>`
          + `<text x="${x + w + 10}" y="${y + h / 2 + 8}" font-size="24" font-weight="800" fill="#231F20" font-family="Figtree, Arial, sans-serif">${state.h}${IN}</text>`;
      }
      const label = `<text x="${mk.cx}" y="${ay + ah + 30}" text-anchor="middle" font-size="20" font-weight="700" fill="rgba(35,31,32,.65)" font-family="Figtree, Arial, sans-serif">Print area ${mk.aw}${IN} × ${mk.ah}${IN}</text>`;
      return `<svg viewBox="0 0 ${imgW} ${imgW}" role="img" aria-label="Your design on the bag"><image href="${mk.img}${mk.img.includes('?') ? '&' : '?'}width=1000" x="0" y="0" width="${imgW}" height="${imgW}"/>`
        + `<rect x="${ax}" y="${ay}" width="${aw}" height="${ah}" fill="rgba(250,178,25,.06)" stroke="rgba(35,31,32,.45)" stroke-width="2" stroke-dasharray="8 6"/>${label}${art}</svg>`;
    };

    /* ---------- design tools ---------- */
    const toolsHTML = () => {
      if (state.busy) return `<p class="bee-bag__tool-msg is-busy">${state.busy === 'bg' ? 'Removing the background…' : 'Trimming empty space…'} This can take a few seconds.</p>`;
      const i = state.info;
      if (!i) return '';
      let h = '';
      if (state.edit) {
        h += `<p class="bee-bag__tool-msg is-ok"><span><strong>✓ ${state.edit === 'bg' ? 'Background removed' : 'Empty space trimmed'}.</strong> Check the preview on the bag.</span><button type="button" class="bee-bag__tool-link" data-undo>Undo</button></p>`;
        if (state.edit === 'bg' && analyzeTrim()) h += `<button type="button" class="bee-bag__tool" data-tool="trim">Trim empty space</button>`;
      } else if (i.hasBg && state.team) {
        h += `<p class="bee-bag__tool-msg is-ok"><span><strong>✓ Our team will remove the background</strong> by hand before printing. It's free.</span></p>`;
      } else if (i.hasBg) {
        h += `<p class="bee-bag__tool-msg is-warn"><span><strong>Your file has a background.</strong> DTF prints everything that isn’t transparent, so it would print as a solid box on the bag.</span></p>`
          + `<button type="button" class="bee-bag__tool" data-tool="bg">${i.solidBg ? 'Remove background' : 'Try automatic removal'}</button>`;
      } else if (i.trimmable) {
        h += `<p class="bee-bag__tool-msg"><span><strong>Your file has empty space around the design.</strong> Trim it so the design fills the size you pick.</span></p>`
          + `<button type="button" class="bee-bag__tool" data-tool="trim">Trim empty space</button>`;
      }
      if (i.hasBg) h += `<label class="bee-bag__team"><input type="checkbox" data-team ${state.team ? 'checked' : ''}><span>${state.edit === 'bg' ? 'Not happy with the result?' : 'Rather not do it yourself?'} <strong>Let our team remove the background by hand</strong> (free).</span></label>`;
      if (state.toolErr) h += `<p class="bee-bag__tool-msg is-err"><span>${state.toolErr}</span></p>`;
      return h;
    };
    const analyzeTrim = () => false;
    const applyImage = (img, keepWidth) => {
      state.ratio = img.naturalHeight / img.naturalWidth || 1;
      state.px = state.vector ? null : { w: img.naturalWidth, h: img.naturalHeight };
      let w = keepWidth;
      if (!w) {
        let fit = fitArea();
        if (state.px) { const sw = state.px.w / 300; if (sw < fit.w) fit = { w: f1(sw), h: f1(sw * state.ratio) }; }
        w = fit.w;
      }
      const f = fitArea();
      w = Math.min(w, f.w);
      state.w = Math.max(1, r1(w)); state.h = r1(state.w * state.ratio);
      state.pos = state.pos ? clampPos(state.pos.x, state.pos.y) : null;
    };
    const runTool = async (kind) => {
      state.busy = kind; state.toolErr = '';
      render();
      await frame();
      const job = ++state.job;
      try {
        const img = await loadImg(state.edit === 'bg' && kind === 'trim' ? state.url : state.orig.url);
        const blob = await processImage(img, kind === 'bg');
        if (job !== state.job) return;
        const base = state.orig.file.name.replace(/\.[^.]+$/, '');
        const file = new File([blob], `${base}-${kind === 'bg' ? 'no-background' : 'trimmed'}.png`, { type: 'image/png' });
        const url = URL.createObjectURL(file);
        const im2 = await loadImg(url);
        if (state.url && state.url !== state.orig.url) URL.revokeObjectURL(state.url);
        state.file = file; state.url = url; state.vector = false;
        state.edit = kind; state.team = false; state.img = im2;
        if (DRIVE.url) { state.up = startUp(file); paintUp(); }
        applyImage(im2, state.w);
      } catch (e) {
        state.toolErr = 'Sorry, we couldn’t edit this file automatically. Our team can fix it for you: tick the box below or add a note.';
      }
      state.busy = null;
      render();
    };
    const undoEdit = () => {
      if (!state.edit) return;
      if (state.url && state.url !== state.orig.url) URL.revokeObjectURL(state.url);
      state.file = state.orig.file; state.url = state.orig.url; state.vector = state.orig.vector;
      state.edit = null;
      if (state.origUp) { state.up = state.origUp; paintUp(); }
      loadImg(state.url).then((im) => { state.img = im; applyImage(im, state.w); render(); }).catch(() => render());
    };
    toolsEl.addEventListener('click', (e) => {
      const b = e.target.closest('button');
      if (!b) return;
      if (b.matches('[data-tool]')) runTool(b.dataset.tool);
      else if (b.matches('[data-undo]')) undoEdit();
    });
    toolsEl.addEventListener('change', (e) => {
      if (!e.target.matches('[data-team]')) return;
      state.team = e.target.checked;
      if (state.team && state.edit === 'bg') undoEdit(); else render();
    });

    /* ---------- render ---------- */
    const render = () => {
      const v = variant();
      const unit = v ? v.price : 0;
      els.price.textContent = fmt(unit);
      els.priceNote.textContent = state.custom ? `Bag + your full-color DTF print` : `Blank bag · add your design for ${fmt(priceOf(true) - priceOf(false))} more`;
      els.print.querySelectorAll('[data-print-opt]').forEach((b) => {
        const on = (b.dataset.printOpt === 'custom') === state.custom;
        b.setAttribute('aria-pressed', String(on));
        const pr = b.querySelector('[data-opt-price]');
        if (pr) pr.textContent = fmt(priceOf(b.dataset.printOpt === 'custom'));
      });
      if (els.colors) els.colors.querySelectorAll('[data-color]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.color === state.color)));
      els.custom.hidden = !state.custom;
      const showMock = state.custom && mk;
      els.mock.hidden = !showMock;
      els.mockCap.hidden = !showMock;
      els.gallery.classList.toggle('is-mock', !!showMock);
      if (showMock) {
        els.mock.innerHTML = mockSVG();
        const colorNote = state.color && data.photoColor && state.color.toLowerCase() !== data.photoColor.toLowerCase() ? ` · shown in ${data.photoColor.toLowerCase()}` : '';
        els.mockCap.innerHTML = state.url
          ? `<strong>${state.w}${IN} × ${state.h}${IN}</strong> on a ${esc(data.bagSize)} bag · true scale · drag to move, pull a corner to resize${colorNote}`
          : `Upload your design to see it on the bag · print area ${mk.aw}${IN} × ${mk.ah}${IN}${colorNote}`;
      }
      const th = state.custom ? toolsHTML() : '';
      toolsEl.hidden = !th;
      toolsEl.innerHTML = th;
      els.sizeBox.hidden = !state.url;
      if (state.url) {
        if (document.activeElement !== els.w) els.w.value = state.w;
        if (document.activeElement !== els.h) els.h.value = state.h;
        els.measure.innerHTML = (state.px ? `Your file is <strong>${state.px.w} × ${state.px.h} px</strong> · sharp up to ${r1(state.px.w / 300)}${IN} × ${r1(state.px.h / 300)}${IN}` : 'Vector file: stays sharp at any size.') + (state.edit ? ' <span class="bee-bag__tag">Edited</span>' : '');
      }
      const q = quality();
      if (state.custom && q.msgs.length) {
        els.qa.hidden = false;
        els.qa.className = `bee-bag__qa is-${q.level}`;
        els.qa.innerHTML = q.msgs.map((m) => `<p>${m}</p>`).join('') + (q.level === 'bad' ? `<label class="bee-bag__ack"><input type="checkbox" data-ack ${state.ackFor === sig() ? 'checked' : ''}> I understand and want it printed this way.</label>` : '');
      } else { els.qa.hidden = true; els.qa.innerHTML = ''; }
      els.total.textContent = fmt(unit * state.qty);
      els.add.disabled = !v || !v.available;
    };

    /* ---------- gallery ---------- */
    if (els.thumbs) els.thumbs.addEventListener('click', (e) => {
      const b = e.target.closest('[data-thumb]');
      if (!b) return;
      els.main.src = b.dataset.thumb;
      els.thumbs.querySelectorAll('[data-thumb]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      if (state.custom) { state.custom = false; render(); }
    });

    /* ---------- events ---------- */
    els.print.addEventListener('click', (e) => {
      const b = e.target.closest('[data-print-opt]');
      if (!b) return;
      state.custom = b.dataset.printOpt === 'custom';
      els.err.hidden = true;
      render();
      if (state.custom && window.matchMedia('(max-width: 989px)').matches) els.gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    if (els.colors) els.colors.addEventListener('click', (e) => {
      const b = e.target.closest('[data-color]');
      if (!b) return;
      state.color = b.dataset.color;
      const v = variant();
      if (v && v.image && !state.custom) els.main.src = v.image;
      render();
    });
    els.file.addEventListener('change', () => {
      const f = els.file.files && els.file.files[0];
      els.file.value = '';
      if (!f) return;
      const limit = DRIVE.url ? DRIVE_MAX : SHOPIFY_MAX;
      if (f.size > limit) { els.err.textContent = `This file is ${mb(f.size)}. The limit is ${mb(limit)}, so please upload a smaller file or contact us.`; els.err.hidden = false; return; }
      els.err.hidden = true;
      if (state.url) URL.revokeObjectURL(state.url);
      if (state.orig && state.orig.url !== state.url) URL.revokeObjectURL(state.orig.url);
      state.file = f;
      state.url = URL.createObjectURL(f);
      state.vector = /svg/.test(f.type);
      state.pos = null; state.edit = null; state.team = false; state.toolErr = ''; state.info = null; state.busy = null; state.job++;
      state.orig = { file: f, url: state.url, vector: state.vector };
      state.ref = Math.random().toString(36).slice(2, 10);
      state.img = null;
      state.up = DRIVE.url ? startUp(f) : null;
      state.origUp = state.up;
      paintUp();
      const img = new Image();
      img.onload = () => {
        state.img = img;
        applyImage(img, null);
        if (!state.vector) { try { state.info = analyze(img); } catch (e) { state.info = null; } }
        els.dropTitle.textContent = f.name;
        els.dropSub.textContent = 'Tap to replace your design';
        els.drop.classList.add('has-file');
        render();
      };
      img.onerror = () => {
        state.ratio = 1; state.px = null; state.w = Math.min(mk.aw, mk.ah); state.h = state.w;
        els.dropTitle.textContent = f.name;
        els.dropSub.textContent = 'We can’t preview this file type, but we’ll check it before printing.';
        els.drop.classList.add('has-file');
        render();
      };
      img.src = state.url;
    });
    const setW = (w) => { if (!(w > 0)) return; state.w = r1(w); state.h = r1(w * (state.ratio || 1)); state.pos = state.pos ? clampPos(state.pos.x, state.pos.y) : null; render(); };
    els.w.addEventListener('input', () => setW(parseFloat(els.w.value)));
    els.h.addEventListener('input', () => { const h = parseFloat(els.h.value); if (h > 0) setW(h / (state.ratio || 1)); });
    els.fill.addEventListener('click', () => { const f = fitArea(); state.pos = null; setW(f.w); });
    root.addEventListener('change', (e) => { if (e.target.matches('[data-ack]')) { state.ackFor = e.target.checked ? sig() : null; els.err.hidden = true; } });
    els.notes.addEventListener('input', () => { state.notes = els.notes.value; });
    { const hint = root.querySelector('.bee-bag__hint'); if (hint) hint.textContent = 'Drag your design to move it, or drag a corner to resize. Proportions stay locked.'; }
    root.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => { state.qty = Math.max(1, Math.min(9999, state.qty + Number(b.dataset.step))); els.qty.value = state.qty; render(); }));
    els.qty.addEventListener('input', () => { state.qty = Math.max(1, Math.min(9999, parseInt(els.qty.value, 10) || 1)); render(); });

    /* drag the design inside the print area */
    els.mock.addEventListener('pointerdown', (e) => {
      const g = e.target.closest('[data-drag]');
      if (!g || !state.w) return;
      e.preventDefault();
      const svg = g.ownerSVGElement;
      const m = svg.getScreenCTM().inverse();
      const pt = (ev) => new DOMPoint(ev.clientX, ev.clientY).matrixTransform(m);
      const p0 = pt(e);
      const base = state.pos || { x: 0, y: 0 };
      try { els.mock.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      const handle = e.target.closest('[data-resize]');
      if (handle) {
        /* corner drag = new print size, shape locked, opposite corner stays put, never bigger than the print area */
        const corner = handle.dataset.resize;
        const ratio = state.ratio || 1;
        const cx0 = base.x, cy0 = base.y;
        const ax = cx0 + (corner.includes('w') ? state.w / 2 : -state.w / 2);
        const ay = cy0 + (corner.includes('n') ? state.h / 2 : -state.h / 2);
        const maxW = Math.min(mk.aw, mk.ah / ratio);
        let raf = 0;
        const resize = (ev) => {
          const p = pt(ev);
          const px = (p.x - mk.cx) / mk.ppi, py = (p.y - mk.cy) / mk.ppi;
          let w = Math.max(Math.abs(px - ax), Math.abs(py - ay) / ratio);
          w = r1(Math.min(maxW, Math.max(1, w)));
          const h = r1(w * ratio);
          state.w = w; state.h = h;
          const nx = corner.includes('w') ? ax - w / 2 : ax + w / 2;
          const ny = corner.includes('n') ? ay - h / 2 : ay + h / 2;
          state.pos = clampPos(nx, ny);
          if (!raf) raf = requestAnimationFrame(() => { raf = 0; render(); });
        };
        const done = () => { els.mock.removeEventListener('pointermove', resize); els.mock.removeEventListener('pointerup', done); els.mock.removeEventListener('pointercancel', done); render(); };
        els.mock.addEventListener('pointermove', resize);
        els.mock.addEventListener('pointerup', done);
        els.mock.addEventListener('pointercancel', done);
        return;
      }
      const move = (ev) => {
        const p = pt(ev);
        state.pos = clampPos(base.x + (p.x - p0.x) / mk.ppi, base.y + (p.y - p0.y) / mk.ppi);
        els.mock.innerHTML = mockSVG();
      };
      const up = () => { els.mock.removeEventListener('pointermove', move); els.mock.removeEventListener('pointerup', up); els.mock.removeEventListener('pointercancel', up); render(); };
      els.mock.addEventListener('pointermove', move);
      els.mock.addEventListener('pointerup', up);
      els.mock.addEventListener('pointercancel', up);
    });

    /* placement preview (photo + design) for the order */
    const previewPNG = () => new Promise((resolve) => {
      try {
        const c = document.createElement('canvas'); c.width = c.height = 800;
        const g = c.getContext('2d');
        const bag = new Image(); bag.crossOrigin = 'anonymous';
        bag.onload = () => {
          g.drawImage(bag, 0, 0, 800, 800);
          const art = new Image();
          art.onload = () => {
            const k = 800 / imgW, p = mk.ppi * k;
            const w = state.w * p, h = state.h * p, pos = state.pos || { x: 0, y: 0 };
            g.drawImage(art, mk.cx * k + pos.x * p - w / 2, mk.cy * k + pos.y * p - h / 2, w, h);
            try { c.toBlob((b) => resolve(b), 'image/jpeg', 0.85); } catch (e) { resolve(null); }
          };
          art.onerror = () => resolve(null);
          art.src = state.url;
        };
        bag.onerror = () => resolve(null);
        bag.src = `${mk.img}${mk.img.includes('?') ? '&' : '?'}width=800`;
      } catch (e) { resolve(null); }
    });

    /* add to cart */
    $('[data-form]').addEventListener('submit', async (e) => {
      e.preventDefault();
      els.err.hidden = true;
      const v = variant();
      if (!v) return;
      if (state.custom) {
        if (!state.file) { els.err.textContent = 'Upload your design, or choose Blank.'; els.err.hidden = false; els.drop.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (quality().level === 'bad' && state.ackFor !== sig()) { els.err.textContent = 'Please check the print warning above: change the size, or tick the box to confirm.'; els.err.hidden = false; els.qa.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      }
      els.add.classList.add('is-busy');
      buzz(els.addLabel, state.custom ? 'sending your design' : 'adding to your cart');
      let tick = 0;
      try {
        const fd = new FormData();
        fd.append('id', v.id);
        fd.append('quantity', state.qty);
        if (state.custom) {
          let link = null, origLink = null;
          if (state.up) {
            tick = setInterval(() => { if (state.up && state.up.state === 'busy') buzz(els.addLabel, `sending your design ${Math.round(state.up.pct * 100)}%`); }, 250);
            try { link = await state.up.promise; } catch (er) { link = null; }
            if (state.edit && state.origUp && state.origUp !== state.up) { try { origLink = await state.origUp.promise; } catch (er) { origLink = null; } }
            clearInterval(tick); tick = 0;
            buzz(els.addLabel, 'adding to your cart');
          }
          if (!link && state.file.size > SHOPIFY_MAX) throw new Error(`Your file (${mb(state.file.size)}) could not be uploaded. Please check your connection and try again, or contact us.`);
          const prev = mk ? await previewPNG() : null;
          if (prev) fd.append('properties[Preview]', new File([prev], `bag-preview-${Date.now()}.jpg`, { type: 'image/jpeg' }));
          if (link) {
            /* the print file lives in Drive; Shopify only gets a small preview so the cart can show it */
            const t = await thumbOf();
            if (t) fd.append('properties[Design]', new File([t], `preview-${state.file.name.replace(/\.[^.]+$/, '')}.png`, { type: 'image/png' }));
            else fd.append('properties[Design]', state.file.name);
            fd.append('properties[_Print file]', link);
            fd.append('properties[_File name]', `${state.file.name} (${mb(state.file.size)})`);
            if (state.edit && origLink) fd.append('properties[_Original file]', origLink);
          } else {
            /* Drive was unreachable: keep the order going with the file on Shopify (small files only) */
            fd.append('properties[Design]', state.file);
            if (state.edit && state.orig && state.orig.file.size <= SHOPIFY_MAX) fd.append('properties[_Original file]', state.orig.file);
          }
          fd.append('properties[_Ref]', state.ref);
          if (state.edit) fd.append('properties[Edited]', state.edit === 'bg' ? 'Background removed (automatic)' : 'Empty space trimmed');
          if (state.team) fd.append('properties[Background removal]', 'By our team (free)');
          fd.append('properties[Print size]', `${state.w}${IN} × ${state.h}${IN}`);
          const pos = state.pos || { x: 0, y: 0 };
          fd.append('properties[_Placement]', `centre ${pos.x >= 0 ? '+' : ''}${r1(pos.x)}${IN} x, ${pos.y >= 0 ? '+' : ''}${r1(pos.y)}${IN} y from print-area centre`);
          const q = quality();
          if (q.level === 'bad') fd.append('properties[Customer approved]', 'Print warning acknowledged');
          if (state.notes.trim()) fd.append('properties[Instructions]', state.notes.trim());
        }
        const res = await fetch(`${data.addUrl}.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || 'Could not add to cart.'); }
        location.href = data.cartUrl;
      } catch (ex) {
        if (tick) clearInterval(tick);
        els.err.textContent = ex.message; els.err.hidden = false;
        els.add.classList.remove('is-busy'); els.addLabel.textContent = addText;
      }
    });

    render();
  };

  const boot = () => document.querySelectorAll('.bee-bag').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
